import Culture from "@/module/main/page/CultureEnum";

class Generator {
    public getNumber(max: number, min: number = 0): number {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    public getRandomIdent(): string {
        const year: string = this.getPaddedRandomNumberAsString(90, 60);
        const month: string = this.getPaddedRandomNumberAsString(12, 1, 2);
        const day: string = this.getPaddedRandomNumberAsString(28, 1, 2);

        let rest: string;
        let lastChar: number;
        do {
            rest = this.getPaddedRandomNumberAsString(999, 0, 3);
            const ident: string = `${year}${month}${day}${rest}`;
            lastChar = Number(ident) % 11;
        } while (lastChar === 10);

        return `${year}${month}${day}/${rest}${lastChar}`;
    }

    private getPaddedRandomNumberAsString(max: number, min: number = 0, width: number = 0): string {
        return this.getNumber(max, min)
            .toString()
            .padStart(width, "0");
    }

    public getRandomPhoneNumber(culture: Culture): string {
        let countryCode: string;
        let part1: string;

        if (culture == Culture.SK) {
            countryCode = "+421";
            part1 = "9" + this.getPaddedRandomNumberAsString(5) + this.getPaddedRandomNumberAsString(9);
        } else {
            countryCode = "+420";
            part1 = this.getPaddedRandomNumberAsString(7, 6) + this.getPaddedRandomNumberAsString(99, 0, 2);
        }

        const part2: string = this.getPaddedRandomNumberAsString(999, 0, 3);
        const part3: string = this.getPaddedRandomNumberAsString(999, 0, 3);

        return `${countryCode}${part1}${part2}${part3}`;
    }

    public getOrderNumber(): string {
        return this.getPaddedRandomNumberAsString(1000000, 100000);
    }
}

export default new Generator();
